module.exports = __webpack_public_path__ + "static/media/spiner-ico.9dd125ff.png";